﻿export class RioOmniBoxResultApiModel<T> {
    item: T;
    matches: number;
}